import React from "react";
import SeeAllShows from "../see-all-shows/SeeAllShows";
import MoreFromCurrentShow from "../more-from-current-show/MoreFromCurrentShow";
import ShowModule from "../show-module/ShowModule";

export default function BelowTheFold({
    relatedSeriesAndVideosData,
    recircShowModules,
}) {
    return (
        <div className="video-article__below-the-fold">
            <MoreFromCurrentShow
                relatedSeriesAndVideosData={relatedSeriesAndVideosData}
            />
            <ul className="video-article__show-modules">
                {recircShowModules &&
                    recircShowModules.length > 0 &&
                    recircShowModules.map((showModule) => (
                        <li
                            className="video-article__show-module"
                            key={`module-${showModule.id}`}
                        >
                            <ShowModule {...showModule} />
                        </li>
                    ))}
            </ul>
            <SeeAllShows />
        </div>
    );
}
